<template>
  <div>
    <main>
      <div class="wrapper" :style="`width: calc(100vw - ${sideNavWidth}px)`">
        <client :id="$route.params.ruleId" :title="title" isTemplate />
      </div>
    </main>
    <unsavedChangesModal
      :value="showLeaveConfirmation"
      @closeModal="cancelConfirmation"
      @confirmLeave="leave"
    />
  </div>
</template>
    
<script>
import { mapGetters } from "vuex";
import client from "@/components/client";
import unsavedChangesModal from "@/components/unsaved-changes-modal";

export default {
  components: {
    client,
    unsavedChangesModal,
  },
  data() {
    return {
      showLeaveConfirmation: false,
      deferredRoute: undefined,
    };
  },
  methods: {
    cancelConfirmation() {
      this.showLeaveConfirmation = false;
      this.deferredRoute = undefined;
    },
    leave() {
      this.$router.push(this.deferredRoute);
    },
  },
  computed: {
    title() {
      return (
        (this.mergedConfig &&
          this.mergedConfig[this.$route.params.ruleId] &&
          this.mergedConfig[this.$route.params.ruleId].Info &&
          this.mergedConfig[this.$route.params.ruleId].Info.TemplateName) ||
        "Edit Template"
      );
    },
    ...mapGetters({
      sideNavWidth: "getSideNavWidth",
      mergedConfig: "getMergedConfig",
      hasUpdatedConfigValues: "hasUpdatedConfigValues",
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.hasUpdatedConfigValues[this.$route.params.ruleId] &&
      !this.deferredRoute
    ) {
      this.deferredRoute = to;
      this.showLeaveConfirmation = true;
      next(false);
    } else {
      this.$store.dispatch("clearNewConfigValues");
      next();
    }
    this.$store.dispatch("closeRightPanel");
  },
};
</script>
    
<style lang="scss" scoped>
main {
  height: calc(100vh - $header-height);
  .wrapper {
    height: 100%;
  }
}
</style>